export default __webpack_public_path__ + "static/avatar-kayi-common-9-cover-623333da3c8025337ceb4472a64f69a9.png";